import React, { useState, useEffect, memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import { getOwners } from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const OwnersPdf = () => {
    const [owners, setOwners] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        setIsLoading(true);
        const { owners } = await getOwners();
        setOwners(owners);
        setIsLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Spinner open={isLoading} />
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Κωδ.'}</Text>
                                <Text style={styles.headers}>{'Επώνυμο'}</Text>
                                <Text style={styles.headers}>{'Όνομα'}</Text>
                                <Text style={styles.headers}>{'Πατρώνυμο'}</Text>
                                <Text style={styles.headers}>{'Διεύθ.'}</Text>
                                <Text style={styles.headers}>{'Πόλη'}</Text>
                                <Text style={styles.headers}>{'Σταθερό'}</Text>
                                <Text style={styles.headers}>{'Κινητό'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {owners.map((item) =>
                                <View key={item._id} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{item.code}</Text>
                                    <Text style={styles.cell}>{item.lastName}</Text>
                                    <Text style={styles.cell}>{item.firstName}</Text>
                                    <Text style={styles.cell}>{item.fatherName}</Text>
                                    <Text style={styles.cell}>{item.address}</Text>
                                    <Text style={styles.cell}>{item.city}</Text>
                                    <Text style={styles.cell}>{item.phoneNumber}</Text>
                                    <Text style={styles.cell}>{item.cellPhone}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(OwnersPdf);
